export const SITE_URL = (import.meta.env.VITE_SITE_URL || 'https://www.couteausuissedigital.com').replace(/\/$/, '');

export const absoluteUrl = (path: string): string => {
  if (!path || path === '/') {
    return SITE_URL;
  }

  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  return `${SITE_URL}${cleanPath}`;
};
